import i18n from '@/libs/i18n'

export const INBOUND_VENDOR_CODES = {
  JOHN_DEERE: 'johndeere',
  CNH: 'cnh',
  CNH_CONSTRUCTION: 'cnhconstruction',
  KOMATSU: 'komatsu',
}

export function getInboundVendorOptions() {
  return [
    { label: i18n.t('John Deere'), value: INBOUND_VENDOR_CODES.JOHN_DEERE },
    { label: i18n.t('CNH Agro'), value: INBOUND_VENDOR_CODES.CNH },
    { label: i18n.t('CNH Construction'), value: INBOUND_VENDOR_CODES.CNH_CONSTRUCTION },
    { label: i18n.t('Komatsu'), value: INBOUND_VENDOR_CODES.KOMATSU },
  ]
}

export function getInboundVendorFilterOptions() {
  return [
    { label: i18n.t('All Manufacturers'), value: null },
    ...getInboundVendorOptions(),
  ]
}

export function getInboundVendorLabel(code) {
  if (!code) return ''
  const match = getInboundVendorOptions().find(
    option => option.value === String(code).toLowerCase(),
  )
  return match ? match.label : code
}

export function isPasswordInboundVendor(code) {
  return String(code || '').toLowerCase() === INBOUND_VENDOR_CODES.KOMATSU
}
